const isEnter = (keyEvent) => keyEvent.charCode === 13;
export default isEnter;
